module.exports = __webpack_public_path__ + "static/pam-franchising-84ea3e65918460fe41ddf177a0b82131.jpg";